import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ContactImportsAPI from '../../api/contactImports';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getContactImports($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContactImport: $state => id => {
    return $state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async function getContactImports({ commit }) {
    commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isFetching: true });
    try {
      const response = await ContactImportsAPI.get();
      commit(types.SET_CONTACT_IMPORTS, response.data);
      commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isFetching: false });
      throw error;
    }
  },

  create: async function createContactImport({ commit }, importData) {
    commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactImportsAPI.create(importData);
      commit(types.ADD_CONTACT_IMPORT, response.data);
      commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isCreating: false });
      return response.data;
    } catch (error) {
      commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isCreating: false });
      throw error;
    }
  },

  delete: async function deleteContactImport({ commit }, id) {
    commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isDeleting: true });
    try {
      await ContactImportsAPI.delete(id);
      commit(types.DELETE_CONTACT_IMPORT, id);
      commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isDeleting: false });
    } catch (error) {
      commit(types.SET_CONTACT_IMPORT_UI_FLAG, { isDeleting: false });
      throw error;
    }
  },

  downloadTemplate: async function downloadTemplate() {
    try {
      const response = await ContactImportsAPI.getTemplate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'contact_import_template.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      throw error;
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_IMPORT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONTACT_IMPORTS]: MutationHelpers.set,
  [types.ADD_CONTACT_IMPORT]: MutationHelpers.create,
  [types.DELETE_CONTACT_IMPORT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
